import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_core/_services/authentication.service';
import { UserService } from '../../_services/user.service';
import { PageTitleService } from '../../_services/page-title.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  isSidebarCollapsed = false;
  currentYear = new Date().getFullYear();
  pageInfo$ = this.pageTitleService.pageInfo$;

  constructor(
    public authenticationService: AuthenticationService,
    public userService: UserService,
    private pageTitleService: PageTitleService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Check if user has a preference for sidebar state
    const savedState = localStorage.getItem('sidebarCollapsed');
    if (savedState !== null) {
      this.isSidebarCollapsed = JSON.parse(savedState);
    }
  }

  onToggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    localStorage.setItem('sidebarCollapsed', JSON.stringify(this.isSidebarCollapsed));
  }

  onCloseSidebar(): void {
    this.isSidebarCollapsed = true;
    localStorage.setItem('sidebarCollapsed', JSON.stringify(this.isSidebarCollapsed));
  }

  get mainContentClass(): string {
    return this.isSidebarCollapsed ? 'main-content collapsed' : 'main-content expanded';
  }
}
